<div
  class="container p-0-20"
>
  <p
    [innerHTML]="'pages.localisation.map_info' | translate"
  >
  </p>
</div>
<app-gmap
  [latitude]="agencyService.agency.latitude"
  [longitude]="agencyService.agency.longitude"
  [pathColor]="'#7cb650'"
  [travelModes]="travelModes"
  id="map"
>
</app-gmap>
<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="container"
>
  <p
    class="hotspots-info p-0-20"
  >
    {{ 'pages.localisation.subtitle' | translate }}
  </p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center start"
    class="hotspots"
  >
    <div
      *ngFor="let category of pointsOfInterestCategories"
      fxLayout="column"
      fxLayoutAlign="center start"
      class="hotspots-category"
    >
      <h1
        fxLayout="row"
        fxLayoutAlign="center center"
        class="hotspots-title"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="gradient-background"
        >
          <img
            [src]="category.icon"
            alt=""
            class="hotspot-icon"
          >
        </div>
        {{ category.title }}
      </h1>
      <h2
        *ngFor="let point of category.points"
        class="hotspot"
        (click)="onInterestPointClick(point)"
      >
        {{ point.title | truncate:45 }}
      </h2>
    </div>
  </div>
</div>

<app-contact-us
  [component]="'localisation'"
>
</app-contact-us>



// WEBPACK FOOTER //
// ./src/app/localisation/localisation.component.html